export { delegateUrl } from "./vercel.js";
import { parse as vercelParse, transform as vercelTransform } from "./vercel.js";
export const parse = url => Object.assign({}, vercelParse(url), {
  cdn: "nextjs"
});
export const transform = params => vercelTransform(Object.assign({}, params, {
  cdn: "nextjs"
}));